export const HomePageModule = "Home Page";
export const AlertsModule = "Alerts";
export const CameraModule = "Cameras";
export const HMModule = "Health Monitoring";
export const PanelControlModule = "Panel Control";
export const ReportsModule = "Reports";
export const CustomReportsModule = "Custom Reports";
export const ConfigToolModule = "Configuration Tool";
export const VideoBackupModule = "Video Backup";
export const QualityControlModule = "Quality Control";